var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChooseDevice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4944 28.0472C15.5719 28.342 15.3962 28.6439 15.1016 28.7221C14.807 28.8004 14.5047 28.6255 14.4257 28.3311C14.3466 28.0368 14.5207 27.734 14.8149 27.6542C15.1111 27.5751 15.4152 27.7511 15.4944 28.0472",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3496 32.393L51.3678 31.043C52.5473 30.7187 53.2423 29.5014 52.9221 28.3207L47.7418 9.02285C47.4174 7.84442 46.2017 7.1497 45.0217 7.46854L44.1335 7.70834",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2634 15.4619L9.6323 16.974C8.45276 17.2984 7.75774 18.5156 8.07798 19.6963L13.2672 38.9942C13.5915 40.1726 14.8073 40.8674 15.9872 40.5485L36.7217 34.9841",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.0269 18.4327C33.0269 20.2721 31.5357 21.7633 29.6963 21.7633C27.8568 21.7633 26.3656 20.2721 26.3656 18.4327V9.55088C26.3656 7.71141 27.8568 6.22021 29.6963 6.22021C31.5357 6.22021 33.0269 7.71141 33.0269 9.55088V18.4327Z",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3656 20.6534C26.3656 22.4929 24.8744 23.984 23.0349 23.984C21.1954 23.984 19.7042 22.4929 19.7042 20.6534V11.7716C19.7042 9.93211 21.1954 8.44092 23.0349 8.44092C24.8744 8.44092 26.3656 9.93211 26.3656 11.7716V20.6534Z",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.6882 16.2125C39.6882 18.0519 38.197 19.5431 36.3575 19.5431C34.518 19.5431 33.0269 18.0519 33.0269 16.2125V7.33067C33.0269 5.49119 34.518 4 36.3575 4C38.197 4 39.6882 5.49119 39.6882 7.33067V16.2125Z",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2473 39.5272C35.2467 36.5248 36.9755 33.7906 39.6882 32.5039",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7042 39.5605V40.6375C19.7042 42.0353 20.3623 43.3515 21.4806 44.1902L22.3688 44.8563C23.487 45.695 24.1451 47.0112 24.1451 48.409V55.0704",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6882 32.504V25.0943C39.6882 23.2549 41.1794 21.7637 43.0189 21.7637C44.8584 21.7637 46.3496 23.2549 46.3496 25.0943V37.3068C46.35 39.9559 44.7807 42.3534 42.3528 43.413C40.7337 44.1197 39.6874 45.7187 39.6882 47.4853V55.0704",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChooseDevice);
export default __webpack_public_path__ + "static/media/icon-choose-device.127e9a32.svg";
export { ForwardRef as ReactComponent };